import { motion } from "framer-motion";
import { EASE } from "./Reveal";

const GOLD = "#D4AF37";

function Defs({ v }) {
  return (
    <defs>
      <pattern id={`dg-${v}`} width="30" height="30" patternUnits="userSpaceOnUse">
        <circle cx="1.2" cy="1.2" r="1.2" fill="rgba(212,175,55,0.16)" />
      </pattern>
      <linearGradient id={`gg-${v}`} x1="0" y1="1" x2="0" y2="0">
        <stop offset="0%" stopColor="#B8860B" />
        <stop offset="100%" stopColor="#F3E5AB" />
      </linearGradient>
      <radialGradient id={`gl-${v}`} cx="50%" cy="45%" r="65%">
        <stop offset="0%" stopColor="rgba(212,175,55,0.14)" />
        <stop offset="100%" stopColor="rgba(212,175,55,0)" />
      </radialGradient>
    </defs>
  );
}

function Bars({ v }) {
  const bars = [0.3, 0.44, 0.56, 0.7, 0.86];
  return (
    <motion.g initial="hidden" whileInView="show" viewport={{ once: true, margin: "-15% 0px" }}>
      {bars.map((f, i) => (
        <motion.rect
          key={i}
          x={62 + i * 58}
          width="26"
          variants={{ hidden: { height: 0, y: 420 }, show: { height: 340 * f, y: 420 - 340 * f } }}
          transition={{ duration: 1.2, delay: i * 0.12, ease: EASE }}
          fill={i === bars.length - 1 ? `url(#gg-${v})` : "none"}
          stroke={GOLD}
          strokeOpacity={i === bars.length - 1 ? 0 : 0.55}
          strokeWidth="1.2"
        />
      ))}
      <motion.line
        x1="40" y1="420" x2="362" y2="420"
        variants={{ hidden: { pathLength: 0 }, show: { pathLength: 1 } }}
        transition={{ duration: 1.4, ease: EASE }}
        stroke={GOLD} strokeWidth="1.5"
      />
    </motion.g>
  );
}

const NODES = [
  [80, 120], [165, 78], [262, 140], [322, 88], [122, 222],
  [222, 244], [312, 212], [92, 332], [202, 352], [302, 322], [152, 432], [262, 422],
];
const EDGES = [[0, 1], [1, 2], [2, 3], [0, 4], [1, 5], [2, 5], [3, 6], [4, 5], [5, 6], [4, 7], [5, 8], [6, 9], [7, 8], [8, 9], [8, 10], [9, 11], [10, 11], [5, 10]];

function Network() {
  return (
    <motion.g initial="hidden" whileInView="show" viewport={{ once: true, margin: "-15% 0px" }}>
      {EDGES.map(([a, b], i) => (
        <motion.line
          key={i}
          x1={NODES[a][0]} y1={NODES[a][1]} x2={NODES[b][0]} y2={NODES[b][1]}
          variants={{ hidden: { pathLength: 0, opacity: 0 }, show: { pathLength: 1, opacity: 1 } }}
          transition={{ duration: 1.1, delay: i * 0.07, ease: EASE }}
          stroke={GOLD} strokeOpacity="0.5" strokeWidth="1"
        />
      ))}
      {NODES.map(([cx, cy], i) => (
        <motion.circle
          key={i}
          cx={cx} cy={cy}
          variants={{ hidden: { r: 0 }, show: { r: i === 5 ? 7 : 4 } }}
          transition={{ duration: 0.7, delay: 0.4 + i * 0.06, ease: EASE }}
          fill={i === 5 ? GOLD : "#fff"}
          stroke={GOLD} strokeWidth="1.2"
        />
      ))}
    </motion.g>
  );
}

function Orbits() {
  return (
    <motion.g
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: "-15% 0px" }}
      transition={{ duration: 1.4, ease: EASE }}
    >
      {[58, 108, 158].map((r) => (
        <circle key={r} cx="200" cy="250" r={r} fill="none" stroke={GOLD} strokeOpacity="0.45" strokeWidth="1" />
      ))}
      <circle cx="200" cy="250" r="10" fill={GOLD} />
      <circle cx="200" cy="250" r="18" fill="none" stroke={GOLD} strokeOpacity="0.6" strokeWidth="1" />
      {[
        { r: 58, d: 14, s: 4 },
        { r: 108, d: 22, s: 5.5 },
        { r: 158, d: 34, s: 4.5 },
      ].map((o, i) => (
        <motion.g
          key={i}
          animate={{ rotate: i % 2 ? -360 : 360 }}
          transition={{ duration: o.d, repeat: Infinity, ease: "linear" }}
          style={{ transformOrigin: "200px 250px" }}
        >
          <circle cx={200 + o.r} cy="250" r={o.s} fill={GOLD} />
        </motion.g>
      ))}
    </motion.g>
  );
}

export default function ChapterArt({ variant }) {
  return (
    <svg viewBox="0 0 400 500" preserveAspectRatio="xMidYMid slice" className="h-full w-full bg-white">
      <Defs v={variant} />
      <rect width="400" height="500" fill={`url(#gl-${variant})`} />
      <rect width="400" height="500" fill={`url(#dg-${variant})`} />
      {variant === "01" && <Bars v={variant} />}
      {variant === "02" && <Network />}
      {variant === "03" && <Orbits />}
    </svg>
  );
}
